import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { GetEvents } from "../../apis/api/EventsApi";
import { useDispatch, useSelector } from "react-redux";

const EventsMenu = () => {
  const [hovered, setHovered] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const navigateCard = (Event) => {
    navigate("/EventsCards", { state: { Event,from: location.pathname, } });
  };
  
  useEffect(() => {
    dispatch(GetEvents())
  }, [])

  const { events } = useSelector((state) => state.EventSlice)

  const pastEvent = events?.filter((event) => event.status === "past")
  const currentEvent = events?.filter((event) => event.status === "current")
 
  return (
    <div className=" ">
     
      <div className="row">

        <div className="col-md-6  d-flex" onClick={()=>navigateCard(currentEvent)}>
          <motion.div
            className="card event-card w-100"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onMouseEnter={() => setHovered("current")}
            onMouseLeave={() => setHovered(null)}
            style={{
              minHeight: "300px",
           
              backgroundSize: "cover",
              backgroundPosition: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <motion.div
              animate={{
                backgroundImage:
                  hovered === "current"
                    ? `url("images/events/Meeting-and-Conferences-4-480x320.jpeg")`
                    : "none",
              }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              className="card-background"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundSize: "cover",
                backgroundPosition: "center",
                zIndex: -1,
              }}
            />
            <motion.img
              src="images/events/Event-Management-Tips-5.jpg"
              className="card-img-top"
              alt="Current Event"
              loading="lazy" 
              animate={{ opacity: hovered === "current" ? 0 : 1 }}
              transition={{ duration: 0.5 }}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <div className="card-overlay">
              <motion.h3
                className={`event-text ${hovered === "current" ? "hovered" : ""}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                Current Event
              </motion.h3>
            </div>
          </motion.div>
        </div>

        
        <div className="col-md-6  d-flex" onClick={()=>navigateCard(pastEvent)}>
          <motion.div
            className="card event-card w-100"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onMouseEnter={() => setHovered("past")}
            onMouseLeave={() => setHovered(null)}
            style={{
              minHeight: "20px",
          
              backgroundSize: "cover",
              backgroundPosition: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <motion.div
              animate={{
                backgroundImage:
                  hovered === "past"
                    ? `url("images/events/1508444023549.jpeg")`
                    : "none",
              }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              className="card-background"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundSize: "cover",
                backgroundPosition: "center",
                zIndex: -1,
              }}
            />
            <motion.img
              src="images/events/2025-04-15 12-45-19.png"
              className="card-img-top"
              alt="Past Event"
              loading="lazy" 
              animate={{ opacity: hovered === "past" ? 0 : 1 }}
              transition={{ duration: 0.5 }}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <div className="card-overlay">
              <motion.h3
                className={`event-text ${hovered === "past" ? "hovered" : ""}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                Past Event
              </motion.h3>
            </div>
          </motion.div>
        </div>
      </div>
    </div>

  );
};

export default EventsMenu;
